import { getDescSortParam } from '../utils/sort'

export const BIRDVIEW_ATTENTION_API =
  'idwell-api/api/v3/widget/dashboard/attention/'

export const BIRDVIEW_DWELLER_ANNOUNCEMENTS_API =
  'idwell-api/api/v3/widget/dashboard/dweller/announcements/'

export const BIRDVIEW_DWELLER_DOCUMENTS_API =
  'idwell-api/api/v3/widget/dashboard/dweller/documents/'

export const BIRDVIEW_DWELLER_HOME_API =
  'idwell-api/api/v3/widget/dashboard/dweller/home/'

export const BIRDVIEW_DWELLER_MESSAGES_API =
  'idwell-api/api/v3/widget/dashboard/dweller/messages/'

export const BIRDVIEW_DWELLER_OBJECTS_API =
  'idwell-api/api/v3/widget/dashboard/dweller/objects/'

export const BIRDVIEW_DWELLER_REQUESTS_API =
  'idwell-api/api/v3/widget/dashboard/dweller/requests/'

export const BIRDVIEW_INSIGHTS_KPI_TILES_API =
  'idwell-api/api/v3/widget/dashboard/insights/kpi-tiles/'

export const BIRDVIEW_INSIGHTS_OPENED_CLOSED_API =
  'idwell-api/api/v3/widget/dashboard/insights/opened-closed/'

export const BIRDVIEW_INSIGHTS_REQUESTS_AGING_API =
  'idwell-api/api/v3/widget/dashboard/insights/requests-aging/'

export const BIRDVIEW_INSIGHTS_REQUESTS_BY_BUILDING_API =
  'idwell-api/api/v3/widget/dashboard/insights/requests-by-building/'

export const BIRDVIEW_INSIGHTS_REQUESTS_BY_CATEGORY_API =
  'idwell-api/api/v3/widget/dashboard/insights/requests-by-category/'

export const BIRDVIEW_INSIGHTS_REQUESTS_BY_MANAGER_API =
  'idwell-api/api/v3/widget/dashboard/insights/requests-by-manager/'

export const BIRDVIEW_INSIGHTS_REQUESTS_BY_STATUS_API =
  'idwell-api/api/v3/widget/dashboard/insights/requests-by-status/'

export const BIRDVIEW_MY_ACTIVITIES_API =
  'idwell-api/api/v3/widget/dashboard/my-activities/'

export const BIRDVIEW_MY_COMMUNICATIONS_API =
  'idwell-api/api/v3/widget/dashboard/my-communications/'

export const BIRDVIEW_MY_CRITICAL_REQUESTS_API =
  'idwell-api/api/v3/widget/dashboard/my-critical-requests/'

export const BIRDVIEW_MY_SERVICE_REQUESTS_API =
  'idwell-api/api/v3/widget/dashboard/my-service-requests/'

export const BIRDVIEW_PORTFOLIO_OVERVIEW_API =
  'idwell-api/api/v3/widget/dashboard/portfolio-overview/'

export const BIRDVIEW_SUMMARY_API =
  'idwell-api/api/v3/widget/dashboard/summary/'

export const BIRDVIEW_TEAM_LOAD_API =
  'idwell-api/api/v3/widget/dashboard/team-load/'

export const BIRDVIEW_SECTION_ITEMS_LIMIT = 5

export const BIRDVIEW_DOC_FLOWS_ORDERING = [getDescSortParam('updated')]
